import React from 'react'
import Global from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import { TopFirstView } from 'src/components/organisms/top/TopFirstView'
import TopConcept from 'src/components/organisms/top/TopConcept'
import TopAbout from 'src/components/organisms/top/TopAbout'
import { TopFeatures } from 'src/components/organisms/top/TopFeatures'
import TopTeam from 'src/components/organisms/top/TopTeam'
import TopShip from 'src/components/organisms/top/TopShip'
import TopClient from 'src/components/organisms/top/TopClient'
import TopSeminars from 'src/components/organisms/top/TopSeminars'
import { TopWhitePapers } from 'src/components/organisms/top/TopWhitePapers'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import { TopProblems } from 'src/components/organisms/top/TopProblems'
import { TopBanner } from 'src/components/organisms/top/TopBanner'
import { TopVideo } from 'src/components/organisms/top/TopVideo'
import { TopAward } from 'src/components/organisms/top/TopAward'

class IndexPage extends React.Component {
  render() {
    return (
      <>
        <SEO top={true} title="TOP" />
        <Global />
        <Header top />
        <TopFirstView />
        <TopAward />
        <TopVideo />
        <TopConcept />
        <TopAbout  top/>
        <TopProblems />
        <TopClient top />
        <TopFeatures />
        <TopShip />
        <TopTeam />
        <TopSeminars />
        <TopWhitePapers />
        <Footer />
      </>
    )
  }
}

export default IndexPage
